export const checkDirRights = (dir, rights) => {

    if (!dir || !rights ) return ''

    const nt = `dir${dir.charAt(0).toUpperCase()}${dir.slice(1)}`;
    return (
        rights?.[`${nt}-view`] ||
        rights?.[`${nt}-create`] ||
        rights?.[`${nt}-edit`] ||
        rights?.[`${nt}-delete`] ||
        rights?.[`${nt}-approve`]
    );
};